export const getId = (heading?: string) => {
    return `#${heading?.toLowerCase().replaceAll(' ', '-')}`;
};
